import { NavigateFunction } from "react-router-dom";
import type { SortDescriptor } from "react-aria-components";

export function handlePaginationChange(navigate: NavigateFunction, page: number) {
  const url = new URL(window.location.href);
  url.searchParams.set("page", page.toString());
  navigate(url.pathname + url.search);
}

export function handleSort(
  navigate: NavigateFunction,
  column: string,
  direction: string
) {
  const url = new URL(window.location.href);
  if (direction === "none") {
    url.searchParams.delete("sort");
  } else {
    url.searchParams.set("sort", `${column}:${direction}`);
  }
  // Reset to first page when sorting changes
  url.searchParams.set("page", "0");
  navigate(url.pathname + url.search);
}

export function parseSortDescriptor(
  sortParam: string | undefined,
  defaultColumn: string,
  defaultDirection: "ascending" | "descending"
): SortDescriptor {
  if (!sortParam) {
    return { column: defaultColumn, direction: defaultDirection };
  }

  const [column, direction] = sortParam.split(":");
  return {
    column: column || defaultColumn,
    direction: (direction as "ascending" | "descending") || defaultDirection,
  };
}
